import { Button, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader } from '@heroui/react';

export type ToolUnlockModalEntry = 'download' | 'strip' | 'hero';

const BENEFITS = ['Unlimited exports on creator tools', 'Pay once — lifetime access', 'No subscription required'] as const;

type ToolUnlockValueModalProps = {
  isOpen: boolean;
  entry: ToolUnlockModalEntry;
  isLoading: boolean;
  onClose: () => void;
  onUnlock: () => void;
  onStartTrial: () => void;
};

/**
 * Explains the $4.99 lifetime unlock before opening Stripe checkout.
 */
export function ToolUnlockValueModal({
  isOpen,
  entry: _entry,
  isLoading,
  onClose,
  onUnlock,
  onStartTrial,
}: ToolUnlockValueModalProps) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="sm" placement="center" aria-label="Unlock creator tools">
      <ModalContent className="overflow-hidden">
        <ModalHeader className="flex flex-col items-center gap-1 pb-0 pt-6 text-center">
          <p className="text-xs font-medium uppercase tracking-wide text-foreground-500">Lifetime unlock</p>
          <h2 className="font-sans text-2xl font-semibold leading-tight text-foreground">$4.99 once</h2>
        </ModalHeader>
        <ModalBody className="gap-5 px-6 pb-2 pt-3">
          <p className="text-center text-sm text-foreground-600">
            Unlock downloads across Kreatli creator tools. Checkout opens in a new tab — your file stays here.
          </p>
          <ul className="mx-auto flex w-full max-w-xs flex-col gap-2.5">
            {BENEFITS.map((item) => (
              <li key={item} className="flex items-center gap-2.5 text-sm text-foreground">
                <span
                  className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-foreground text-[10px] font-semibold text-content1"
                  aria-hidden
                >
                  ✓
                </span>
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </ModalBody>
        <ModalFooter className="flex flex-col gap-2 px-6 pb-6 pt-2">
          <Button className="h-11 w-full bg-foreground text-content1" isLoading={isLoading} onPress={onUnlock}>
            Unlock for $4.99
          </Button>
          <Button className="w-full" variant="light" onPress={onClose}>
            Not now
          </Button>
          <button
            type="button"
            className="pt-1 text-center text-xs text-foreground-500 underline-offset-2 hover:text-foreground hover:underline"
            onClick={onStartTrial}
          >
            Or start a free trial
          </button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
